import styled from "styled-components"

export const Title = styled.p`
margin: 0;
text-align: center;
font-size: 2.5rem;
font-weight: bold;
/* margin-top: 4rem; */
`

export const FieldsContainer = styled.div`
  display: flex;
  justify-content:flex-end;
  align-items: center;
  // width: 20%;
  column-gap: 1rem;
  margin-bottom: 2rem;

  // @media (max-width: 1300px) {
  //   width: 50rem;
  // }
`;

export const CardContainer = styled.div`
display: flex;
flex-direction: column;
row-gap: 2rem;
align-items:center;
padding:1rem;
`





/// new styling of cards collectables




export const CardsMain = styled.div`
  width: 100%;
  justify-content: flex-start;
  /* display: flex; */
  display: grid;
  grid-template-columns: auto auto auto auto;
  justify-content: center;
  row-gap: 3.9rem;
  /* column-gap: 3.9rem; */
  column-gap: 0.5rem;
  overflow: hidden;
  overflow-x: auto;
  padding-bottom: 30px;
  margin-bottom: -20px;
  padding-left: 1rem;
  padding-right: 1rem;
   @media (max-width: 1700px) {
    grid-template-columns: auto auto auto;
  }
  @media (max-width: 1300px) {
    grid-template-columns: auto auto;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 22rem;
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  border-radius: 12px;
  border: ${({ active }) => (active ? "2px solid #2a3da3": "none")};
  cursor: pointer;
  width: 20rem;
  height: auto;
background:white;
  // :hover {
  //   border: 1px solid #2a3da3;
  // }

  @media (max-width: 2630px) {
    //  height: 26rem;
    max-width: 25rem;
  }
  /* height: 25rem; */
  /* row-gap: 3rem; */
`;

export const CardsHead = styled.div``;

export const CardImg = styled.div`
  display: flex;
  align-items: center;
`;

export const CardDetails = styled.div`
  // for the two sections of image and details
  width: 100%;
  display: flex;
  margin: 10px;
  // justify-content: space-between;
  @media (max-width: 1250px) {
    /* flex-direction: ${(props) => (props.allowColumn ? "column" : "row")}; */
    flex-direction: column;
  }
`;

export const CardDetailsColumn = styled.div`
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
`;

export const CardItemsLarge = styled.div`
  // section for the item p large
  display: flex;
  flex-direction: column;
  flex-wrap: warp;
`;

export const CardItemsSmall = styled.div`
  // sections for items small
  display: flex;
  margin-top: auto;
  flex-wrap: warp;
`;

export const Img = styled.img`
  max-width: 100%;
  // border-top-left-radius: 1rem;
  // border-top-right-radius: 1rem;
  // height: 100%;
  object-fit: contain;
  max-height:214px;
  // aspect-ratio: 1/1;

  @media (max-width: 2630px) {
    max-height: 214px;
    max-width: 100%;
  }
`;

export const PropertyCardDetails = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0rem 0.5rem 0 1rem;
`;

export const PropertyCardH3 = styled.h3`
  font-size: 1.4vw;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 1300px) {
    font-size: 1.27rem;
  }
`;

export const Desc = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1rem;
  padding: 0.5rem 0 0.5rem 1rem;
  @media (max-width: 2630px) {
    line-height: 1rem;
  }
`;

export const Counts1 = styled.div`
  -webkit-box-shadow: 0 0 7px #c1c1c1;
  box-shadow: 0 0 7px #c1c1c1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  width: 22rem;
  border-radius: 1rem;
  background-color: white;

  @media (max-width: 2630px) {
    width: 22rem;
  }
`;
